export default {
      id: "look-grey-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#look-grey",
      toString: function () {
        return this.url;
      }
    }